export var CardBrand;
(function (CardBrand) {
    CardBrand["UNKNOWN_CARD_BRAND"] = "UNKNOWN_CARD_BRAND";
    CardBrand["AMEX"] = "AMEX";
    CardBrand["DANKORT"] = "DANKORT";
    CardBrand["DINERS"] = "DINERS";
    CardBrand["DISCOVER"] = "DISCOVER";
    CardBrand["ISRACARD"] = "ISRACARD";
    CardBrand["JCB"] = "JCB";
    CardBrand["MAESTRO"] = "MAESTRO";
    CardBrand["MASTERCARD"] = "MASTERCARD";
    CardBrand["UNIONPAY"] = "UNIONPAY";
    CardBrand["VISA"] = "VISA";
    CardBrand["RUPAY"] = "RUPAY";
})(CardBrand || (CardBrand = {}));
export var RequestedFields;
(function (RequestedFields) {
    /** Default value. This value is unused. */
    RequestedFields["UNKNOWN_REQUESTED_FIELD"] = "UNKNOWN_REQUESTED_FIELD";
    RequestedFields["SENSITIVE_INFO"] = "SENSITIVE_INFO";
})(RequestedFields || (RequestedFields = {}));
export var WebhookIdentityType;
(function (WebhookIdentityType) {
    WebhookIdentityType["UNKNOWN"] = "UNKNOWN";
    WebhookIdentityType["ANONYMOUS_VISITOR"] = "ANONYMOUS_VISITOR";
    WebhookIdentityType["MEMBER"] = "MEMBER";
    WebhookIdentityType["WIX_USER"] = "WIX_USER";
    WebhookIdentityType["APP"] = "APP";
})(WebhookIdentityType || (WebhookIdentityType = {}));
//# sourceMappingURL=types.impl.js.map